import React, { Fragment, useState } from 'react';
import { st } from './texte'
import { setCardInfo } from './Interface.js'
import DatatransForm from './DatatransForm'
import moment from 'moment';

const AddCardData = (props) => { 
  const { appState, setState, change, checkConfirm, dispCheckInfo, konfig, paymentinfo } = props;
  const [saving, setSaving] = useState(false);

  const doneSaving = () => {setSaving(false)}

  const storeDatatrans = async (dtTok) => {
    setSaving(true);
    const meta = { inhaber: appState.cc_inhaber, expmonth: appState.cc_expmonth, expyear: appState.cc_expyear };
    setCardInfo(appState, setState, 'datatrans', dtTok, meta, doneSaving);
  }

  const status = 'zahlungDatatrans'; // ohne Betrag, immer token l�sen
/*
weiche gem�ss app.js (aber vorerst nur Datatrans token, weil betrag==0)
        if (this.state.paymentinfo.BookingFee !== 'noPaymentInfo') {
          const PreisJetzt = calcPreisJetzt(this.state);
          if (this.state.paymentinfo.BookingFee===constants.bfDatatransToken) {
            if (PreisJetzt<0.1 || this.state.paymentinfo.PaymentProvider === "3") {
              statusneu = 'zahlungDatatrans';
            }
            else {
              statusneu = 'zahlungStripe';
            }
          }
          else if (this.state.paymentinfo.BookingFee===constants.bfStripe || this.state.paymentinfo.BookingFee===constants.bfLocalcheck) 
          {
            if ((this.state.paymentinfo.BookingFee===constants.bfLocalcheck && PreisJetzt<0.1) || this.state.paymentinfo.storePaymentInfo) {
              statusneu = 'zahlungNostripe';
            }
            else {
              statusneu = 'zahlungStripe';
            }
          }
          else if (this.state.bookNoCC) {
            this.setBooking();
          }
        }
        else {
          this.setBooking();
        }
*/

  const preisDisp = 0;
  
  if (!paymentinfo) return null;
  if (!paymentinfo.DatatransMerchantId) return null;

  let msg = false;
  if (appState.error) {
    const error = appState.error.split('|');
    msg = st['bwh.carddataError.'+error[0]] || st['bwh.carddataError.internalServerError'];
    if (error[1]) {
      const d = moment.unix(error[1]);
      msg += ' '+d.format('MM/YYYY');
    }
  }
  return (
    <Fragment>
      <div id="buchungfertig" className="clearfix">
        <div className="clearfix">
          <h1>{st['bwh.carddatatitel']}</h1>
          {msg && <h2>{msg}</h2>}
        </div>
      </div>

  {status === 'zahlungDatatrans'?
        <>
    {!appState?.PciCardInfo?.TimeStamp && !saving && 
          <DatatransForm preis={preisDisp} appState={appState} setAppState={setState} konfig={konfig} 
            setBookingDatatrans={storeDatatrans} change={change} 
            checkConfirm={checkConfirm} dispCheckInfo={dispCheckInfo} addcc={true} />
    }
    {!!appState?.PciCardInfo?.TimeStamp &&
          <div id="zahlungsdatenFormular_formular_datatrans" className="clearfix formularansicht">
            <div id="buchungfertig" className="clearfix">
              <div className="clearfix">
                <h1>{st['bwh.carddataRegistered']}</h1>
              </div>
            </div>
            <div className="formularfeld clearfix" >
              <p className="formularfeld-label">{st['bwh.zahlungsdaten.formular.inhaber'].slice(0,-1)}</p>
              <p className="formularfeld-label">{appState.PciCardInfo.Cardholder}</p>
            </div>
            <div className="formularfeld clearfix" >
              <p className="formularfeld-label">{st['bwh.zahlungsdaten.formular.nummer'].slice(0,-1)}</p>
              <p className="formularfeld-label">{appState.PciCardInfo.maskedCC}</p>
            </div>
            <div className="formularfeld clearfix" >
              <p className="formularfeld-label">{st['bwh.zahlungsdaten.formular.ablauf'].slice(0,-1)}</p>
              <p className="formularfeld-label">{appState.PciCardInfo.ExpireDate}</p>
            </div>
          </div>
    }
        </>
  :null}
{/*
  {status === 'zahlungNostripe'?
        <StripeProvider apiKey={paymentinfo.stripe_pk}>
          <Elements>
            <CCDatenNoStripe appState={this.state} setAppState={this.setAppState} checkConfirm={this.checkConfirm} 
              dispCheckInfo={this.dispCheckInfo} setBooking={this.setBooking}
              ref={this._CCNoStripe} konfig={konfig} change={this.handleCCFeld} paymentinfo={this.state.paymentinfo} 
              preis={preisDisp} />
          </Elements>
        </StripeProvider>
  :null}
  {status === 'zahlungStripe'?
        <StripeProvider apiKey={paymentinfo.stripe_pk} locale={stripeLocale} >
          <Elements>
            <StripeForm appState={appState} setAppState={setState} checkConfirm={checkConfirm} dispCheckInfo={dispCheckInfo}
              preis={preisDisp} setBooking={storeStripe} logtext={logtext} addcc={true} />
          </Elements>
        </StripeProvider>
  :null}
*/}

  </Fragment>
  )
}
export default AddCardData;
